import type { IconName } from "../icons/iconNames.generated";

export enum DetailsTooltipContentItemType {
  EMAIL = "email",
  PHONE = "phone",
  ADDRESS = "address",
  TEMPLATE = "template",
  PARENT = "parent",
  OTHER = "other",
}

export type DetailsTooltipContentItem =
  | {
      type:
        | DetailsTooltipContentItemType.PHONE
        | DetailsTooltipContentItemType.EMAIL
        | DetailsTooltipContentItemType.TEMPLATE
        | DetailsTooltipContentItemType.PARENT
        | DetailsTooltipContentItemType.OTHER;
      text: string;
      action?: () => void;
      /** EMAIL only: overrides the default `mailto:` anchor href (e.g. an Email-draft compose route). */
      href?: string;
    }
  | {
      type: DetailsTooltipContentItemType.ADDRESS;
      text: string[];
      action?: () => void;
    };

export interface DetailsTooltipContent {
  title: string;
  items: DetailsTooltipContentItem[];
  avatarUrl?: string;
  avatarColorIdx?: number;
  isPerson?: boolean;
  specialIcon?: IconName;
  defaultModuleIcon?: IconName;
}
